import React, { useEffect, useState } from "react";

import { IconButton, Tooltip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

interface CopyPatientIdButtonProps {
  patientId: string;
}

/**
 * Small icon button that copies the given patient id to the clipboard.
 */
const CopyPatientIdButton: React.FC<CopyPatientIdButtonProps> = ({
  patientId,
}) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;

    const timeout = window.setTimeout(() => setCopied(false), 1200);
    return () => window.clearTimeout(timeout);
  }, [copied]);

  const handleCopy = async (event: React.MouseEvent) => {
    event.stopPropagation();

    try {
      await navigator.clipboard.writeText(patientId);
      setCopied(true);
    } catch (err) {
      console.error("Failed to copy patient id", err);
    }
  };

  return (
    <Tooltip title={copied ? "Copied" : "Copy patient ID"} placement="top" arrow>
      <IconButton
        size="small"
        aria-label="Copy patient ID"
        onClick={(event) => void handleCopy(event)}
        sx={{ p: 0.25 }}
      >
        {copied ? (
          <CheckIcon sx={{ fontSize: "0.8rem", color: "success.main" }} />
        ) : (
          <ContentCopyIcon sx={{ fontSize: "0.8rem" }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default CopyPatientIdButton;
